export default "__VITE_ASSET__B6yGRV6B__"